import { css } from "lit";

/**
 * Eingabe-Bauteile in der Sprache des Portals — an EINER Stelle
 * (KONZEPT-gestaltungssystem.md, 8.4; Artboard „Auswahlfelder und Eingabe“).
 *
 * DAS FELD IST EINE ZEILE, KEIN KASTEN: Fläche mit Haarlinie unten, 44 px
 * hoch, Mono in Fließtextgröße, der Pfeil des Select ein Zeichen in zweiter
 * Tinte. Nur das fokussierte Feld trägt Petrol (2 px unten) — vier Felder in
 * einem Petrol-Rahmen wären vier Akzente auf einer Seite, die sonst keinen hat.
 *
 * Die Beschriftung ist Mono in Versalien und zweiter Tinte — dieselbe Form
 * wie Auswahl-Zeilen und Tabellenköpfe. Die Breite ist begrenzt: Ein Feld,
 * das über die ganze Spalte läuft, verspricht mehr Eingabe, als ein Ortsname
 * braucht.
 *
 * Der Pfeil ist eine Daten-URI und kann keine CSS-Variable lesen — die Farbe
 * ist deshalb der Hex-Wert von --pd-default-font-muted-col (custom-overrides.css).
 */
export const eingabeStyles = css`
  pd-suggestion-box,
  pd-select,
  pd-input {
    display: block;
    max-width: 22rem;

    --pd-input-label-font-family: var(--portal-font-mono);
    --pd-input-label-font-size: var(--portal-size-meta);
    --pd-input-label-col: var(--portal-ink-2);
    --pd-select-label-font-family: var(--portal-font-mono);
    --pd-select-label-font-size: var(--portal-size-meta);
    --pd-select-label-col: var(--portal-ink-2);

    /* Das Feld: Fläche, Haarlinie unten, Berührziel, Mono. */
    --pd-input-field-height: var(--portal-touch);
    --pd-input-field-padding: 0 var(--portal-space-2);
    --pd-input-field-bg-col: var(--portal-flaeche);
    --pd-input-field-border: none;
    --pd-input-field-border-bottom: 1px solid var(--portal-linie);
    --pd-input-field-border-col-hover: var(--portal-ink-2);
    --pd-input-field-border-focus: 2px solid var(--portal-akzent);
    --pd-default-font-input-size: var(--portal-size-md);
    --pd-radius-md: var(--portal-radius);

    /* Zeichen statt Icon: Lupe und Pfeil in zweiter Tinte, klein. */
    --pd-input-icon-color: var(--portal-ink-2);
    --pd-input-icon-size: 1.1rem;
    --pd-select-arrow-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' fill='none' stroke='%235a6360' stroke-width='1.5'%3E%3Cpath d='M2 4l4 4 4-4'/%3E%3C/svg%3E");
  }
`;
